import { Box, Paper, Typography } from "@mui/material";
import { ReactNode } from "react";

interface TableCardProps {
  title: string;
  children: ReactNode;
  titleColor?: string;
  sx?: Record<string, any>;
  paperSx?: Record<string, any>;
}

const TableCard = ({ title, children, titleColor = "#1B2559", sx, paperSx }: TableCardProps) => (
  <Box sx={sx}>
    <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mb: 1.5 }}>
      <Typography variant="subtitle1" fontWeight={700} sx={{ color: titleColor }}>
        {title}
      </Typography>
    </Box>
    <Paper elevation={0} sx={{ borderRadius: 2, border: "1px solid #E8EBF0", overflow: "hidden", ...paperSx }}>
      {children}
    </Paper>
  </Box>
);

export default TableCard;
